import { Badge } from '@/components/ui/badge'
import { roleLabel, type PortalRole } from '@/features/auth'

/** Administrator reads as the strongest thing someone holds, so it leads.*/
const ROLE_ORDER: Record<PortalRole, number> = { Administrator: 0, Manager: 1, Member: 2 }

const ROLE_VARIANT: Record<PortalRole, 'default' | 'secondary' | 'outline'> = {
  Administrator: 'default',
  Manager: 'secondary',
  Member: 'outline',
}

export function RoleBadges({ roles, className }: { roles: PortalRole[]; className?: string }) {
  const sorted = [...roles].sort((a, b) => ROLE_ORDER[a] - ROLE_ORDER[b])

  return (
    <span className={className ?? 'flex flex-wrap gap-1'}>
      {sorted.map((role) => (
        <Badge key={role} variant={ROLE_VARIANT[role]}>
          {roleLabel(role)}
        </Badge>
      ))}
    </span>
  )
}
